var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { siteX } from "../interceptors/api";
// ==================== API Methods ====================
export const insightsApi = {
    /**
     * Gets aggregated temperature insights data for visualization.
     * Returns counts grouped by time buckets based on date range.
     *
     * Time Aggregation Logic:
     * - ≤ 1 day → group by hour
     * - > 1 day and ≤ 1 month → group by day
     * - > 1 month and ≤ 3 months → group by week
     * - > 3 months and ≤ 1 year → group by month
     * - > 1 year → group by year
     *
     * @param query The query parameters for fetching temperature insights.
     */
    getTemperatureInsights: (query) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield siteX.post("Insights/temperature", query);
        return response.data;
    }),
    /**
     * Gets aggregated alarm insights data for visualization.
     * Returns counts grouped by time buckets based on date range.
     *
     * Time Aggregation Logic:
     * - ≤ 1 day → group by hour
     * - > 1 day and ≤ 1 month → group by day
     * - > 1 month and ≤ 3 months → group by week
     * - > 3 months and ≤ 1 year → group by month
     * - > 1 year → group by year
     *
     * @param query The query parameters for fetching alarm insights.
     */
    getAlarmInsights: (query) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield siteX.post("Insights/alarms", query);
        return response.data;
    }),
};
